
import { Component, Mixins, Emit, Prop, Watch } from "vue-property-decorator";
import { Directory, RootDirectory } from "../../../../../domain/drawing";
import { FormatSet } from "../../../../../domain/format";
import { ITreeCollapsable, ITreeExpandable } from "../../../../system";
import { ModelEditableMixin } from "../../../../system/mixins";
import { ITreeRootSource, ITreeSource } from "../sources";

@Component({
  components: {
  },
})
export default class FormatSetTreeSourceSelectableMixin extends Mixins(ModelEditableMixin) {
  data(): any {
    return {
      rootDirectory: null as RootDirectory<string, FormatSet>,  // ロード中判定のため初期値はnull.
    };
  }
  rootDirectory: RootDirectory<string, FormatSet>;

  mounted(): void {
    this.loadTree();
  }

  loadTree(): void {
    if (!this.treeSource) {
      console.warn("treeSource is empty!!!");
      this.rootDirectory = new RootDirectory([], []);
      return;
    }
    this.rootDirectory = null;
    this.treeSource.getTreeRoot()
    .then(r => this.rootDirectory = r)
    .catch(e => {
      const entityName = this.treeSource.entityName;
      this.$error(
        entityName + "取得失敗",
        entityName + "を読み込めませんでした。",
        e
      );
    });
  }

  @Prop()
  treeSource: ITreeRootSource<FormatSet>;

  @Prop()
  filter: (source: FormatSet | Directory<string, FormatSet>) => boolean;

  @Prop({ default: false })
  shouldIgnoreChained: boolean;
  
  @Watch("treeSource")
  onTreeSourceUpdated(newValue: ITreeSource<FormatSet>, oldValue: ITreeSource<FormatSet>): void {
    this.rootDirectory = null;
    this.loadTree();
  }

  get isLoaded(): boolean {
    return (this.rootDirectory !== null);
  }

  expandSelectorTree(selector: ITreeExpandable): void {
    if (this.isLoaded && selector) {
      selector.expandTree();
    }
  }

  collapseSelectorTree(selector: ITreeCollapsable): void {
    if (this.isLoaded && selector) {
      selector.collapseTree();
    }
  }

  @Emit("nodeDoubleClicked")
  nodeDoubleClicked(): void {}

  @Emit("formatSetSelectionChanged")
  onFormatSetSelectionChanged(value: FormatSet): void {}
}
